import { getItem } from '../../utils/localStorage';
import { getByName } from '../../utils/queryParams';
import { getWindowObject } from '../../utils/window';

export const getFeaturesEnabledByUrl = () =>
  ((getByName('features', '') ?? '') as string).split(',').filter((x) => x);

const isFeatureEnabledByUrl = (feature: string) => {
  // TODO_TYPES: again, qs is a string[].  need to sort out
  const enabledFeatures = getFeaturesEnabledByUrl();

  return enabledFeatures.indexOf(feature) !== -1;
};

const isFeatureEnabledByLocalStore = (feature: string) =>
  getItem(`features.${feature}`) === 'true';

const isFeatureEnabled = (feature: string) => {
  if (getWindowObject('__STORYBOOK_ADDONS', '') !== '') {
    return true;
  }

  return (
    isFeatureEnabledByLocalStore(feature) || isFeatureEnabledByUrl(feature)
  );
};

export default isFeatureEnabled;
